export const carDetailSliderConfig = {
  loop: false,
  slidesPerView: 1,
  centeredSlides: true,
  slideToClickedSlide: true,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: '#carphoto .swiper-button-next',
    prevEl: '#carphoto .swiper-button-prev',
  },
};
